module.exports = __webpack_public_path__ + "static/media/17.d2c1b21f.png";